import React from 'react';
import copy from '../copy';

const useDocumentTitle = (title: string = '') => {
  React.useEffect(() => {
    window.document.title = `${title ? `${title} | ` : ''}${copy.title_suffix}`;
  }, [title]);
};

export default useDocumentTitle;
